module.exports = __webpack_public_path__ + "static/media/service-report.53622c6b.png";